import { createContext, useContext, useMemo, useState } from "react";
import { translate } from "@/lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "es");

  const value = useMemo(() => {
    const t = (key) => translate(lang, key);
    const setLanguage = (l) => {
      localStorage.setItem("lang", l);
      setLang(l);
    };
    const toggle = () => setLanguage(lang === "es" ? "en" : "es");
    return { lang, t, setLanguage, toggle };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
}
